import { OpenInNew } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { PROVIDER_DETAIL_STYLES } from "../../providers/provider-detail/styles";

const GoClientDetail = ({ caseId }) => {
  const navigate = useNavigate();

  function handleGoClientDetail() {
    navigate(`/client-detail/${caseId}/client-info/images`);
  }

  return (
    <button
      onClick={handleGoClientDetail}
      id="go-to-client-detail"
      type="button"
      style={PROVIDER_DETAIL_STYLES.headerActionButton}
    >
      Go to Client Detail
      <OpenInNew style={PROVIDER_DETAIL_STYLES.headerActionIcon} />
    </button>
  );
};

export default GoClientDetail;
